import React, { Dispatch, useState, useContext } from 'react';
import { Tabs, Form, Input, Button, Row, Col, Avatar, Upload, message } from 'antd';
import { UserOutlined, UploadOutlined, UsergroupAddOutlined } from '@ant-design/icons';

import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../store';
import TitlePage from '../../components/TitlePage';
import { Container } from './styled';
import { handleUpdateProfileProps } from '../../store/ducks/auth/types';
import { profileUpdateRequest } from '../../store/ducks/auth/actions';
import { SKW_AUTH, SKW_PREFIX, SKW_URL } from '../../utils/constants';
import api from '../../service/api';
import Swal from 'sweetalert2';
import { useWindowSize } from '../../hook/useWindowSize';
import TableFavoritos from './components/TableFavoritos';
import { AnchorContext } from '../../context/anchor';

const MeusDados: React.FC = () => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const user = useSelector((state: ApplicationState) => state.auth.user);
  const { linkAvatar, setLinkAvatar } = useContext(AnchorContext);
  const { width }: any = useWindowSize();
  const [nome, setNome] = useState<string | undefined>(user?.nome);
  // eslint-disable-next-line
  const [email, setEmail] = useState<string | undefined>(user?.email);
  const dispatch = useDispatch<Dispatch<Action>>();

  const { TabPane } = Tabs;

  const handleUpdateProfile = (values: handleUpdateProfileProps) => {
    if (!values.senha && !values.novaSenha) {
      dispatch(profileUpdateRequest({ nome: values.nome }));
    } else {
      dispatch(
        profileUpdateRequest({
          nome: values.nome,
          novaSenha: values.novaSenha,
          senha: values.senha,
        })
      );
    }
  };

  const props = {
    name: 'prototipo',
    action: `${SKW_URL}/upload?serviceName=${SKW_PREFIX}enviarImagemUsuario&accessKey=${SKW_AUTH}`,
    onChange(info: any) {
      try {
        if (info.file.status === 'done') {
          enviarDocumentoParceiro(info.fileList[0].response[0].filekey);
        }
      } catch (error) {
        message.error(`Upload do arquivo falhou.`);
      }
    },
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  const enviarDocumentoParceiro = (key: string) => {
    try {
      api
        .post(
          `call?serviceName=${SKW_PREFIX}enviarImagemUsuario&token=${token}`,
          {
            chave: key,
            descricao: 'Imagem Usuario',
          },
          {
            responseType: 'arraybuffer',
          }
        )

        .then((res) => {
          Swal.fire({
            title: `Enviado com sucesso!`,
            html: '',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500,
          });
          const base64ImageString = `data:image/png;base64,${Buffer.from(
            res.data,
            'binary'
          ).toString('base64')}`;
          setLinkAvatar(base64ImageString);
        })

        .catch((err) => {
          Swal.fire({
            title: `Não foi possível atualizar a imagem.`,
            html: err.response?.data.titulo,
            icon: 'error',
            showConfirmButton: false,
            timer: 1500,
          });
        });
    } catch (error) {}
  };

  return (
    <Container>
      <TitlePage>Meus dados</TitlePage>
      <Tabs tabPosition={width > 768 ? 'left' : 'top'}>
        <TabPane
          tab={
            <>
              <UserOutlined />
              Dados
            </>
          }
          key="1"
        >
          <Row>
            <Col md={14} sm={24} xs={24}>
              <Form
                layout="vertical"
                onFinish={handleUpdateProfile}
                initialValues={{ nome: `${nome}`, email: `${email}` }}
              >
                <Form.Item
                  label="Nome"
                  name="nome"
                  rules={[{ required: true, message: 'Informe o nome' }]}
                >
                  <Input name={nome} onChange={(e) => setNome(e.target.value)} />
                </Form.Item>

                <Form.Item label="E-mail" name="email">
                  <Input disabled />
                </Form.Item>

                <Form.Item label="Senha atual" name="senha">
                  <Input.Password name="senha" />
                </Form.Item>

                <Form.Item label="Nova senha" name="novaSenha">
                  <Input.Password name="novaSenha" />
                </Form.Item>

                <Form.Item
                  label="Confirmar senha"
                  name="confirmacaoSenha"
                  dependencies={['novaSenha']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('novaSenha') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('As duas senhas que você digitou não coincidem!')
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Alterar Meus Dados
                  </Button>
                </Form.Item>
              </Form>
            </Col>

            <Col md={8} sm={24} xs={24}>
              <div className="avatar">
                <strong>Avatar</strong>
                <Avatar size={86} src={linkAvatar} icon={<UserOutlined />} />
                <Upload {...props} maxCount={1} multiple={false} accept=".png,.jpg">
                  <Button icon={<UploadOutlined />}>Selecionar Imagem</Button>
                </Upload>
              </div>
            </Col>
          </Row>
        </TabPane>

        {/* {user?.perfil !== 'A' ? (
          <TabPane
            tab={
              <>
                <HomeOutlined />
                Centros de distribuição
              </>
            }
            key="2"
          >
            <TableFavoritosCd />
          </TabPane>
        ) : null} */}

        {user?.perfil !== 'A' ? (
          <TabPane
            tab={
              <>
                <UsergroupAddOutlined />
                Parceiros
              </>
            }
            key="3"
          >
            <TableFavoritos />
          </TabPane>
        ) : null}
      </Tabs>
    </Container>
  );
};

export default MeusDados;
